import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import feather from "feather-icons";
import { useDispatch, useSelector } from "react-redux";
import { settingSignUpPassword, settingForgetPassword } from "./services/clientServices";
import { getBotInfo } from "units/bot/services/botService";
import config from "../../config.js";
import { ClipLoader, PulseLoader } from "react-spinners";
import "react-phone-input-2/lib/bootstrap.css";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import { login } from "units/auth/store/authSlice";
import { showToast } from "toast/toastHelper";
import AnimatedBackground from "./component/AnimatedBackground";
import { useTheme } from "units/dashboard/context/ThemeProvider";
import { useTranslation } from "react-i18next";

const ClientEnterPassword = () => {
    const { t } = useTranslation(["client"]);

    const [loading, setLoading] = useState(false);
    const [logo, setLogo] = useState("");
    const [name, setName] = useState("");
    const [status, setStatus] = useState(null);
    const [otpTimer, setOtpTimer] = useState(0);
    const { username } = useParams();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const BASE_URL = config.cdnUrl;

    const otpNumber = JSON.parse(localStorage.getItem("otpCode"));
    const phoneNumber = JSON.parse(localStorage.getItem("phoneNumber"));
    const phoneString = String(phoneNumber);
    const countrycode = JSON.parse(localStorage.getItem("countryCode"));
    const countryCodeString = String(countrycode);
    const { theme } = useTheme();
    useEffect(() => {
        feather.replace();
    }, []);

    useEffect(() => {
        const fetchBotInfo = async () => {
            if (!username) return;
            try {
                const res = await getBotInfo(username);
                if (res?.ok) {
                    setLogo(res.data.logo);
                    setName(res.data.name);
                    localStorage.setItem("logo", JSON.stringify(res.data.logo));
                    setStatus(res.data.status || "unknown");
                }
            } catch (error) {
                console.error("Error fetching bot info:", error);
            }
        };
        fetchBotInfo();
    }, [username]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!password || !confirmPassword) {
            return toast.error(t("enterPassword.requiredFields"));
        }
        if (password !== confirmPassword) {
            return toast.error(t("enterPassword.passwordMismatch"));
        }
        try {
            setLoading(true);
            const payload = {
                countryCode: countryCodeString,
                phone: phoneString,
                otp: otpNumber,
                password: password,
                confirmPassword: confirmPassword,
            };
            const res = await settingSignUpPassword(payload);
            if (!res?.ok) {
                console.log("error for password : " + res.error);
                return showToast(res?.error, "error");
            }
            if (res?.data?.accessToken) {
                dispatch(
                    login({
                        accessToken: res?.data?.accessToken,
                        refreshToken: res?.data?.refreshToken,
                    })
                );
            }
            navigate(`/bot/chatbox/${username}`);
        } catch (err) {
            toast.error(err?.message || t("enterPassword.genericError"));
        } finally {
            setLoading(false);
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        const filteredValue = value.replace(
            /[^A-Za-z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g,
            ""
        );
        setPassword(filteredValue);
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        const filteredValue = value.replace(
            /[^A-Za-z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g,
            ""
        );
        setConfirmPassword(filteredValue);
    };

    return (
        <div className="relative min-h-screen flex flex-col justify-center items-center overflow-hidden">
            <AnimatedBackground />

            {/* استایل رینگ چرخان و کارت شیشه‌ای */}
            <style>{`
                @property --ring-angle {
                    syntax: "<angle>";
                    initial-value: 0deg;
                    inherits: false;
                }
                @keyframes ringTravel {
                    to { --ring-angle: 360deg; }
                }
                .ring-traveler {
                    position: absolute;
                    inset: 0;
                    border-radius: inherit;
                    padding: 2px;
                    background: conic-gradient(
                        from var(--ring-angle),
                        transparent 0deg,
                        transparent 250deg,
                        rgba(20, 184, 166, 0.15) 270deg,
                        #14b8a6 300deg,
                        #FFC505 330deg,
                        #fff7c2 345deg,
                        transparent 360deg
                    );
                    -webkit-mask:
                        linear-gradient(#000 0 0) content-box,
                        linear-gradient(#000 0 0);
                    -webkit-mask-composite: xor;
                            mask-composite: exclude;
                    animation: ringTravel 4s linear infinite;
                    pointer-events: none;
                    z-index: 20;
                }
                .ring-glow {
                    position: absolute;
                    inset: -2px;
                    border-radius: inherit;
                    padding: 3px;
                    background: conic-gradient(
                        from var(--ring-angle),
                        transparent 0deg,
                        transparent 260deg,
                        #14b8a6 305deg,
                        #FFC505 335deg,
                        transparent 360deg
                    );
                    -webkit-mask:
                        linear-gradient(#000 0 0) content-box,
                        linear-gradient(#000 0 0);
                    -webkit-mask-composite: xor;
                            mask-composite: exclude;
                    filter: blur(8px);
                    opacity: 0.85;
                    animation: ringTravel 4s linear infinite;
                    pointer-events: none;
                    z-index: 19;
                }
                .glass-card {
                    background: linear-gradient(
                        135deg,
                        rgba(255, 255, 255, 0.78) 0%,
                        rgba(255, 255, 255, 0.55) 45%,
                        rgba(20, 184, 166, 0.10) 100%
                    );
                    backdrop-filter: blur(24px) saturate(160%);
                    -webkit-backdrop-filter: blur(24px) saturate(160%);
                    border: 1px solid rgba(255, 255, 255, 0.55);
                }
                .glass-card::before {
                    content: "";
                    position: absolute;
                    inset: 0;
                    border-radius: inherit;
                    pointer-events: none;
                    background:
                        radial-gradient(circle at 20% 0%, rgba(255, 197, 5, 0.15), transparent 55%),
                        radial-gradient(circle at 100% 100%, rgba(20, 184, 166, 0.15), transparent 55%);
                }
                .dark .glass-card {
                    background: linear-gradient(
                        135deg,
                        rgba(15, 63, 58, 0.55) 0%,
                        rgba(10, 35, 32, 0.65) 45%,
                        rgba(20, 184, 166, 0.10) 100%
                    );
                    border: 1px solid rgba(94, 234, 212, 0.25);
                }
            `}</style>

            <div className="relative z-10 max-w-md w-[350px] mx-auto">
                <div className="relative rounded-3xl glass-card shadow-[0_20px_60px_-15px_rgba(20,184,166,0.35),0_8px_30px_-10px_rgba(255,197,5,0.25)] dark:!shadow-[0_20px_60px_-15px_rgba(20,184,166,0.5),0_8px_30px_-10px_rgba(255,197,5,0.35)]">
                    {/* هاله‌ی محو پشت نور */}
                    <div className="ring-glow rounded-3xl" />
                    {/* نور دنباله‌دار روی لبه */}
                    <div className="ring-traveler rounded-3xl" />

                    <div className="relative z-10 p-8 rounded-3xl overflow-hidden">
                        {/* هایلایت شیشه بالای کارت */}
                        <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-white/60 dark:!from-teal-200/10 to-transparent rounded-t-3xl" />

                        {otpTimer > 0 && (
                            <div className="absolute w-12 h-12 left-2 top-2 z-20">
                                <ClipLoader
                                    color="#FFC505"
                                    size={48}
                                    speedMultiplier={0.5}
                                    loading={true}
                                />
                                <span className="absolute inset-0 flex items-center justify-center text-gray-700 dark:!text-teal-100 text-sm font-bold">
                                    {otpTimer}
                                </span>
                            </div>
                        )}

                        <div className="relative z-10 rounded-full w-fit mx-auto">
                            <Link to={`/${username}`}>
                                <img
                                    src={logo ? `${BASE_URL}${logo}` : "/defaultLogo.png"}
                                    alt="logo"
                                    className="w-[150px] h-[150px] mx-auto block rounded-full object-cover mb-5 border-3 ring-2 ring-teal-200/70 dark:!ring-teal-400/40 shadow-[0_0_25px_-5px_rgba(255,197,5,0.55)] dark:!shadow-[0_0_25px_-5px_rgba(20,184,166,0.65)]"
                                    onError={(e) => {
                                        e.currentTarget.src = "/defaultLogo.png";
                                    }}
                                />
                            </Link>
                        </div>

                        <h2 className="relative z-10 text-center text-lg flex flex-col justify-center items-center gap-y-2">
                            <span className="font-bold bg-gradient-to-r from-teal-700 via-[#1f3e39] to-yellow-600 dark:!from-teal-300 dark:!via-teal-100 dark:!to-yellow-300 bg-clip-text text-transparent">
                                {`${name?.trim() || username}`}
                            </span>
                            <span className="font-medium text-gray-600 dark:!text-teal-100/80">
                                {t("enterPassword.welcome")}
                            </span>
                        </h2>

                        <form className="relative z-10 mt-8" onSubmit={handleSubmit}>
                            <div>
                                <div className="relative mt-2">
                                    <div className="relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            value={password}
                                            onChange={handlePasswordChange}
                                            placeholder={t("enterPassword.passwordPlaceholder")}
                                            className="w-full border border-white/70 dark:!border-teal-300/30 bg-white/60 dark:!bg-teal-900/40 backdrop-blur-md rounded-xl p-3 pr-10 text-gray-800 dark:!text-teal-50 placeholder:text-gray-500 dark:!placeholder:text-teal-200/50 focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:border-teal-300 placeholder:text-sm"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword((prev) => !prev)}
                                            className="absolute inset-y-0 end-3 flex items-center text-gray-500 dark:!text-teal-200/70 hover:text-teal-700 dark:!hover:text-yellow-200"
                                            tabIndex={-1}
                                        >
                                            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                        </button>
                                    </div>
                                </div>

                                <div className="relative mt-2">
                                    <div className="relative">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            value={confirmPassword}
                                            onChange={handleConfirmPasswordChange}
                                            placeholder={t("enterPassword.confirmPasswordPlaceholder")}
                                            className="w-full border border-white/70 dark:!border-teal-300/30 bg-white/60 dark:!bg-teal-900/40 backdrop-blur-md rounded-xl p-3 pr-10 text-gray-800 dark:!text-teal-50 placeholder:text-gray-500 dark:!placeholder:text-teal-200/50 focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:border-teal-300 placeholder:text-sm"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword((prev) => !prev)}
                                            className="absolute inset-y-0 end-3 flex items-center text-gray-500 dark:!text-teal-200/70 hover:text-teal-700 dark:!hover:text-yellow-200"
                                            tabIndex={-1}
                                        >
                                            {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-5">
                                <button
                                    disabled={loading || otpTimer > 0}
                                    type="submit"
                                    className="
                                        relative w-full py-3 px-4 text-sm tracking-wide rounded-xl
                                        text-white font-bold

                                        bg-gradient-to-r from-teal-700 via-teal-600 to-teal-500
                                        dark:!from-teal-600 dark:!via-teal-500 dark:!to-teal-400

                                        hover:from-teal-800 hover:via-teal-700 hover:to-teal-600
                                        dark:!hover:from-teal-500 dark:!hover:via-teal-400 dark:!hover:to-teal-300

                                        shadow-[0_10px_25px_-8px_rgba(13,148,136,0.7)]
                                        dark:!shadow-[0_10px_25px_-8px_rgba(20,184,166,0.9)]

                                        hover:shadow-[0_12px_30px_-6px_rgba(20,184,166,0.8)]
                                        dark:!hover:shadow-[0_12px_30px_-6px_rgba(94,234,212,0.9)]

                                        transition-all duration-300

                                        focus:outline-none
                                        focus:ring-2 focus:ring-offset-2 focus:ring-teal-500
                                        dark:!focus:ring-teal-300

                                        disabled:opacity-70
                                        disabled:cursor-not-allowed
                                    "
                                >
                                    {!loading ? (
                                        t("enterPassword.submit")
                                    ) : (
                                        <PulseLoader color="#ffffff" size={9} />
                                    )}
                                </button>
                            </div>

                            <div className="flex justify-center mt-3">
                                <Link
                                    to={`/${username}`}
                                    className="text-sm text-teal-700 dark:!text-teal-300 font-bold hover:text-yellow-700 dark:!hover:text-yellow-300 hover:underline transition-colors"
                                >
                                    {t("enterPassword.back")}
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientEnterPassword;